import Vue from 'vue'
import VueCarousel from 'vue-carousel'

Vue.use(VueCarousel)



// WEBPACK FOOTER //
// ./src/front/init/components/carousel.js